<template>
  <div class="page-container">
    <div class="header">
      <div class="title">分账异常管理</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="120px"
        label-position="left">
        <el-row>
          <el-col :span="8">
            <el-form-item label="动账日期" size="small">
              <el-date-picker
                v-model="dateTimeRange"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="流水单号" size="small">
              <el-input v-model="form.splitSerialNo" placeholder="请输入流水单号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商户号" size="small">
              <el-input v-model="form.receiveMerchantId" placeholder="请输入商户号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item size="small">
              <el-button type="primary" @click="handleFormSearch" class="bs-btn" :loading="table.loading">查询</el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button @click="exportTable" class="bs-btn" :loading="exportLoading">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <p style="margin-bottom: 20px;">统计：异常合计{{ sToFixed(table.sumAmount / 100) }}元</p>
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="innerTransferTime" label="动账日期" align="center" min-width="250px" />
        <el-table-column prop="splitSerialNo" label="流水单号" align="center" min-width="150px" />
        <el-table-column prop="receiveMerchantId" label="接收方商编" align="center" min-width="150px" />
        <el-table-column prop="receiveMerchantName" label="商户名称" align="center" min-width="150px" />
        <el-table-column prop="amount" label="分账金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.amount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="处理状态" align="center" min-width="150px">
          <template slot-scope="{row}">{{ statusMap[row.status] || '' }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="80px">
          <template slot-scope="{row}">
            <el-button type="text" @click="openDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="showDetailDialog" width="500px" center>
      <div class="detail-form-container">
        <el-form label-width="100px" label-position="left" class="detail-form">
          <el-form-item label="流水ID">
            <span id="splitSerialNo">{{ detailForm.splitSerialNo || '-' }}</span>
            <copy-btn v-if="detailForm.splitSerialNo" id="#splitSerialNo" />
          </el-form-item>
          <el-form-item label="交易时间">{{ detailForm.splitTime || '-' }}</el-form-item>
          <el-form-item label="交易类型">{{ typeMap[detailForm.type] || '' }}</el-form-item>
          <el-form-item label="收支类型">{{ operateTypeMap[detailForm.operateType] || '' }}</el-form-item>
          <el-form-item label="交易状态">{{ statusMap[detailForm.innerTransferStatus] || '' }}</el-form-item>
          <el-form-item label="业务类型">{{ bizTypeMap[detailForm.bizType] || '-' }}</el-form-item>
          <div class="detail-form-title">分账对象信息</div>
          <el-form-item label="分账接收方">
            <span id="receiveMerchantId">{{ detailForm.receiveMerchantName || '-' }}({{ detailForm.receiveMerchantId || '-' }})</span>
            <copy-btn v-if="detailForm.receiveMerchantId" id="#receiveMerchantId" />
          </el-form-item>
          <el-form-item label="银行卡号">
            <span id="bankAccountNo">{{ detailForm.bankAccountNo || '-' }}</span>
            <copy-btn v-if="detailForm.bankAccountNo" id="#bankAccountNo" />
          </el-form-item>
          <el-form-item label="分账场景">{{ splitAccountSceneMap[detailForm.splitAccountScene] || '' }}</el-form-item>
          <div class="detail-form-title">分账明细</div>
          <el-form-item label="分账金额">￥{{ sToFixed(detailForm.amount / 100) }}</el-form-item>
          <el-form-item label="分账手续费">￥{{ sToFixed(detailForm.fee / 100) }}</el-form-item>
          <el-form-item label="业务流水号">
            <span id="innerTransferNo">{{ detailForm.innerTransferNo || '-' }}</span>
            <copy-btn v-if="detailForm.innerTransferNo" id="#innerTransferNo" />
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// copilot begin
import moment from "moment/moment";
import { debounce, sToFixed } from "@/utils/index";
import { downloadSplitAccountFailRecord, querySplitAccountFailRecord, querySplitSerialFailDetail } from "../../../api/cloud-manage";
import CopyBtn from '@/components/CopyBtn/copy-btn.vue';

export default {
  name: "abnormal-manage",
  components: {
    CopyBtn,
  },
  data() {
    const FORMAT = 'yyyy-MM-DD HH:mm:ss';
    const today = moment().endOf('day').format(FORMAT);
    const sixMonthBefore = moment().subtract(6, 'months').startOf('day').format(FORMAT);
    return {
      statusMap: {
        0: '初始',
        1: '成功',
        2: '失败',
        3: '划转中',
      },
      typeMap: {
        1: '分账 ',
        2: '提现 ',
      },
      operateTypeMap: {
        0: '出账 ',
        1: '入账 ',
      },
      bizTypeMap: {
        1: '商户分账',
        2: '多渠道分账',
      },
      splitAccountSceneMap: {
        1001: 'B2C电商平台',
        1002: 'O2O电商服务平台',
        1003: '共享租赁',
        1004: '知识付费/内容分成',
        1005: '多方合作营销',
        1006: '供应链/连锁经营',
      },
      pickDate: null,
      dateTimeRange: [sixMonthBefore, today],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickDate = (minDate && !maxDate) ? minDate : null;
        },
        disabledDate: (time) => {
          if (this.pickDate) {
            const mPickDate = moment(this.pickDate);
            return (moment(time).isBefore(moment(mPickDate).subtract(6, 'months')) || moment(time).isAfter(moment(mPickDate).add(6, 'months')));
          }
          return false;
        },
      },
      form: {
        splitSerialNo: '',
        receiveMerchantId: '',
      },
      exportLoading: false,
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        sumAmount: 0,
        totalCount: 0,
        pageSize: 10,
      },
      showDetailDialog: false,
      detailForm: {},
    };
  },
  computed: {
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
  },
  mounted() {
    this.handleFormSearch();
  },
  methods: {
    sToFixed,
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        splitSerialNo: '',
        receiveMerchantId: '',
      };
      this.dateTimeRange = [];
      this.handleFormSearch();
    },
    exportTableFunc() {
      const [innerTransferStartTime, innerTransferEndTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        innerTransferStartTime,
        innerTransferEndTime,
      };
      this.exportLoading = true;
      downloadSplitAccountFailRecord(params).then(({ data: { code } }) => {
        if (code === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    async queryTableData() {
      const { pageNo, pageSize } = this.table;
      const [innerTransferStartTime, innerTransferEndTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        pageNo,
        pageSize,
        innerTransferStartTime,
        innerTransferEndTime,
      };
      this.table.loading = true;
      const { data: { data: { list = [], totalCount = 0, sumAmount = 0 } } } = await querySplitAccountFailRecord(params).finally(() => {
        this.table.loading = false;
      });
      this.table.data = list;
      this.table.totalCount = totalCount;
      this.table.sumAmount = sumAmount;
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    openDetail({ splitRelateId }) {
      querySplitSerialFailDetail({ splitRelateId }).then(({ data: { data } }) => {
        this.detailForm = data;
        this.showDetailDialog = true;
      });
    },
  },
};
// copilot end
</script>
<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .detail-form-container {
    padding: 0 20px;

    /deep/ .el-form-item__label {
      font-weight: normal;
      color: #666;
    }

    /deep/ .el-form-item__content {
      color: #333;
      text-align: right;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }

    .detail-form-title {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.detail-section-title {
  position: relative;
  margin: 16px 0;

  &::before {
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 1px;
    content: "";
    background-color: #e0e0e0;
  }
}
</style>
